import { HomePageData } from 'src/modules/home/HomePageMapping.ts';
import { Filter } from 'src/utils/composeFilter.ts';

export function buildReadableFilterStatus(filter: Filter, data: HomePageData) {
    return Object.entries(filter)
        .sort(([name1], [name2]) => name1.localeCompare(name2))
        .reduce((acc, [name, filterValues]) => {
            if (name === 'Type') {
                return acc;
            }
            const attributeValues = data?.[`raw_${name}` as keyof HomePageData];
            if (attributeValues) {
                filterValues.forEach((currentValue) => {
                    const itemValue = attributeValues.values.find(({ value }) => value === currentValue);
                    if (itemValue && acc.find((item) => item === itemValue.label) === undefined) {
                        acc.push(itemValue.label);
                    }
                });
            }
            return acc;
        }, [] as string[])
        .join('; ');
}
